import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const unityRoutes = {
    GET_LIST_BY_KIND: "dashboard/core/unity/listByKind",
    GET_LIST_UNITY_SPACE_TYPE: "global/list/unity-space-types",
    GET_LIST_BY_PAY_BILLING: "dashboard/core/unity/listByPay-billing",
    FIND_BY_INITIALS: "dashboard/core/unity/findByInitials"
};
export default {
    getUnityListByKind(kind, type) {
        return new Promise((resolve) => {
            let newData = [];
            http.get(unityRoutes.GET_LIST_BY_KIND,
                {params: {kindId: kind}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron tipos de " + type);
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar los tipos de " + type);
                        return;
                    }
                    newData = data.info;
                })
                .catch(() => {
                    toast.error("Error al consultar los tipos de " + type);
                })
                .finally(() => {
                    resolve(newData);
                });
        });
    },
    listUnitySpaceType() {
        return new Promise(resolve => {
            let newData = [];
            http.get(unityRoutes.GET_LIST_UNITY_SPACE_TYPE)
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron unidades para los tipos espacio de lotes");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar las unidades");
                        return;
                    }
                    const spaceType = data.info;
                    this.proccessOption(spaceType);
                    newData = spaceType;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

    proccessOption(unitys) {
        unitys.forEach(value => {
                value.id = value.code;
                value.label = value.title;
            }
        );
    },
    listByPayAndBilling(objParams) {
        return new Promise(resolve => {
            let newData = [];
            http.get(unityRoutes.GET_LIST_BY_PAY_BILLING, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron  facturas ni métodos de pago");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los métodos de pago");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    findByInitials(initials) {
        return new Promise(resolve => {
            let newData = {};
            http.get(unityRoutes.FIND_BY_INITIALS, {params: {initial: initials}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontró la unidad con los criterios de búsqueda");
                        newData = data;
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al búscar la  unidad con las iniciales " + initials);
                        newData = data;
                        return;
                    }
                    newData = data;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }
};